import { ErrorHandler, Injectable, inject, isDevMode } from '@angular/core';
import { LogService } from './log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logService = inject(LogService);

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);

    if (this.isIgnoredError(message)) {
      return;
    }

    this.logService.logError('Unhandled error', error).catch(() => undefined);
    if (isDevMode()) {
      console.error('[Correctify]', error);
    }
  }

  private isIgnoredError(message: string): boolean {
    const lower = message.toLowerCase();
    return (
      lower.includes('loading chunk') ||
      lower.includes('failed to fetch') ||
      lower.includes('networkerror') ||
      lower.includes('resizeobserver loop') ||
      lower.includes('non-error promise rejection')
    );
  }
}
